import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { HAMMER_GESTURE_CONFIG, HammerModule, provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { connectAuthEmulator, getAuth, provideAuth } from '@angular/fire/auth';
import { connectFirestoreEmulator, getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { environment } from '../environment/environment';
import { connectStorageEmulator, provideStorage, getStorage } from '@angular/fire/storage';
import { provideStore, StoreModule } from '@ngrx/store';
import { UserModule } from './app-store/user/user.module';
import { userReducer } from './app-store/user/user.reducer';
import { themeReducer } from './app-store/common/common.reducer';
import { ThemeModule } from './app-store/common/common.module';
import { filterReducer } from './app-store/filter/filter.reducer';
import { FilterModule } from './app-store/filter/filter.module';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { CustomHammerConfig } from './hammer-config';
import { HammerDirective } from './hammer-directive';
import { localStorageMetaReducer } from './store/local-storage.meta-reducer';
const e2eMode = !!(environment as { useFirebaseEmulators?: boolean }).useFirebaseEmulators;

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      withPreloading(PreloadAllModules)
    ),
    provideAnimationsAsync(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => {
      const auth = getAuth();
      if (e2eMode) {
        connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
      }
      return auth;
    }),
    provideFirestore(() => {
      const firestore = getFirestore();
      if (e2eMode) {
        connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
      }
      return firestore;
    }),
    ...(e2eMode
      ? []
      : [
          provideAnalytics(() => getAnalytics()),
          ScreenTrackingService,
          UserTrackingService
        ]),
    provideStorage(() => {
      const storage = getStorage();
      if (e2eMode) {
        connectStorageEmulator(storage, '127.0.0.1', 9199);
      }
      return storage;
    }),
            { provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig },
    importProvidersFrom(
      UserModule,
      ThemeModule,
      FilterModule,
      StoreModule.forRoot({ user: userReducer, theme: themeReducer,filter:filterReducer }, {
        metaReducers: e2eMode ? [] : [localStorageMetaReducer]
      }),
    HammerModule,
    HammerDirective

    ),
    provideHttpClient(withFetch()),
    ...(e2eMode
      ? []
      : [
          provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          })
        ]),
    ...(e2eMode ? [] : [provideClientHydration()]),
  ]
};
